import { render, staticRenderFns } from "./AccordionWithTitleDescription.vue?vue&type=template&id=0aba8d13&scoped=true&lang=pug&"
import script from "./AccordionWithTitleDescription.vue?vue&type=script&lang=ts&"
export * from "./AccordionWithTitleDescription.vue?vue&type=script&lang=ts&"
import style0 from "./AccordionWithTitleDescription.vue?vue&type=style&index=0&id=0aba8d13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aba8d13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aba8d13')) {
      api.createRecord('0aba8d13', component.options)
    } else {
      api.reload('0aba8d13', component.options)
    }
    module.hot.accept("./AccordionWithTitleDescription.vue?vue&type=template&id=0aba8d13&scoped=true&lang=pug&", function () {
      api.rerender('0aba8d13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/AccordionWithTitleDescription.vue"
export default component.exports